import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "v-chat" }
const _hoisted_2 = { class: "body" }

import WidgetPanels from "@/components/widget/WidgetPanels.vue";
import CommonFilter from "@/components/common/CommonFilter.vue";
import CommonTable from "@/components/common/CommonTable.vue";
import router from "@/router";
import {useChatStore} from "@/features/chat/chat.store";
import {onMounted, onUnmounted, ref, watch} from "vue";
import {useAppStore} from "@/store/app.store";
import {IChat} from "@/features/chat/chat.types";
import CommonPagination from "@/components/common/CommonPagination.vue";
import {IPaginationMeta} from "@/features/pagination/pagination.types";
import {usePersonalStore} from "@/features/personal/personal.store";


export default /*@__PURE__*/_defineComponent({
  __name: 'ChatView',
  setup(__props) {

const chatStore = useChatStore();
const appStore = useAppStore();
const personalStore = usePersonalStore();

const loading = ref<boolean>(false);
const list = ref<IChat>();
const isFetching = ref<boolean>(false)
const paginationData = ref<IPaginationMeta>()

const handleRowClicked = (row: any, rowIndex: number) => {
  router.push({
    path: `/chat/${row.chat_id}`, query: {
      chat: row.account_id,
      page: paginationData.value?.page,
      page_size: paginationData.value?.page_size,
      prev_page: paginationData.value?.prev_page,
      next_page: paginationData.value?.next_page,
    }
  });
}

const getChats = async () => {
  if (isFetching.value) return

  try {
    isFetching.value = true
    list.value = await chatStore.getChats(loading)
    if (list.value) {
      paginationData.value = {
        has_more: list.value.has_more,
        next_page: list.value.next_page,
        page_size: list.value.page_size,
        page: list.value.page,
        pages: list.value.pages,
        prev_page: list.value.prev_page,
        total: list.value.total,
      }
    }

  } finally {
    isFetching.value = false
  }
}

const handlePageChange = (page: number) => {
  chatStore.commonFilter.page = page;
}

const handleLimitChange = (limit: number) => {
  chatStore.commonFilter.page = 1;
  chatStore.commonFilter.page_size = limit;
}

watch(
    [
      () => appStore.refreshKey,
      () => JSON.stringify(chatStore.commonFilter)
    ],
    () => {
      getChats()
    },
    {immediate: true}
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(WidgetPanels, {
      type: "chats",
      filter: _unref(chatStore).commonFilter
    }, null, 8, ["filter"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(CommonFilter, {
        "with-shift": false,
        "with-date": false,
        "with-outgoing": false,
        loading: loading.value,
        store: _unref(chatStore)
      }, null, 8, ["loading", "store"]),
      _createVNode(CommonTable, {
        items: list.value?.items,
        loading: loading.value,
        headers: _unref(chatStore).headers,
        onRowClicked: handleRowClicked
      }, {
        id: _withCtx(({index}) => [
          _createTextVNode(_toDisplayString((list.value.page - 1) * list.value.page_size + index + 1), 1)
        ]),
        all: _withCtx(({item}) => [
          _createTextVNode(_toDisplayString(item.messages.total), 1)
        ]),
        text: _withCtx(({item}) => [
          _createTextVNode(_toDisplayString(item.messages.text), 1)
        ]),
        voice: _withCtx(({item}) => [
          _createTextVNode(_toDisplayString(item.messages.voice + item.messages.document + item.messages.audio), 1)
        ]),
        call: _withCtx(({item}) => [
          _createTextVNode(_toDisplayString(item.messages.calls), 1)
        ]),
        photo: _withCtx(({item}) => [
          _createTextVNode(_toDisplayString(item.messages.photo + item.messages.video + item.messages.round), 1)
        ]),
        all_errors: _withCtx(({item}) => [
          _createTextVNode(_toDisplayString(item.errors.total), 1)
        ]),
        reply_time: _withCtx(({item}) => [
          _createTextVNode(_toDisplayString(item.errors.reply_time_exceed), 1)
        ]),
        unanswered: _withCtx(({item}) => [
          _createTextVNode(_toDisplayString(item.errors.missed_calls + item.errors.declined_calls), 1)
        ]),
        deleted: _withCtx(({item}) => [
          _createTextVNode(_toDisplayString(item.errors.deleted), 1)
        ]),
        edited: _withCtx(({item}) => [
          _createTextVNode(_toDisplayString(item.errors.edited), 1)
        ]),
        _: 1
      }, 8, ["items", "loading", "headers"])
    ]),
    (list.value && list.value.items && list.value.items.length)
      ? (_openBlock(), _createBlock(CommonPagination, {
          key: 0,
          meta: paginationData.value,
          onChangePage: handlePageChange,
          onChangeLimit: handleLimitChange
        }, null, 8, ["meta"]))
      : _createCommentVNode("", true)
  ]))
}
}

})